import React from "react";
import './App.css'; 
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./Home";
import Profile from "./Profile";
import ChatRoom from "./ChatRoom";
import GroupChatRoom from "./GroupChatRoom";
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/chat/:friendId" element={<ChatRoom />} />
        <Route path="/group/:groupId" element={<GroupChatRoom />} />
      </Routes>
    </Router>
  );
}

export default App;
